module.exports = __webpack_public_path__ + "static/habit-app-cover-f86880f6bc19a26df7fa66df2d283ebb.png";